<template>
  <navbar
    position="fixed"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template slot-scope="{ toggle, isToggled }">
      <div v-popover:popover1 class="navbar-brand">
        <a href="/">
          <img v-if="storeInfo.logo" :src="storeInfo.logo.path" height="60px" />
        </a>
      </div>
    </template>
    <template slot="navbar-menu" slot-scope="{close}">
      <li class="nav-item">
        <router-link class="dropdown-item" :to="{name: 'ProductList'}">
          商品列表
        </router-link>
      </li>
      <li class="nav-item" v-if="isLoggedIn">
        <router-link class="dropdown-item" :to="{name: 'OrderList'}">
          訂單列表
        </router-link>
      </li>
      <li class="nav-item" v-if="isLoggedIn">
        <router-link class="dropdown-item" :to="{name: 'SettingPage'}">
          設定
        </router-link>
      </li>
      <li class="nav-item" v-if="!isLoggedIn">
        <router-link class="dropdown-item" :to="{name: 'Login'}">
          登入
        </router-link>
      </li>
      <li class="nav-item" v-if="isLoggedIn">
        <a href="#" class="dropdown-item" @click.prevent="logout">
          登出
        </a>
      </li>
    </template>
  </navbar>
</template>

<script>
import { DropDown, NavbarToggleButton, Navbar, NavLink } from "@/components";
import { Popover } from "element-ui";
import {AuthService} from "@/services/rest/auth";
import {createNamespacedHelpers} from 'vuex';
const auth = createNamespacedHelpers('Auth');
const store = createNamespacedHelpers('Store');

export default {
  name: "main-navbar",
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover
  },
  computed: {
    ...store.mapState({
      storeInfo: state => state.storeInfo
    }),
    ...auth.mapState({
      isLoggedIn: state => state.isLoggedIn,
    }),
  },
  methods: {
    ...auth.mapMutations(['toggleLogout']),
    goToHome() {
      this.$router.push({name: 'Home'});
    },
    async logout() {
      try {
        await new AuthService().logout();
      } catch (err) {
        console.error(err);
      } finally {
        this.$router.push({name: 'Login'});
        localStorage.clear();
        this.toggleLogout();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar-brand {
  cursor: pointer;
}

@media screen and (max-width: 600px) {
  .navbar-brand {
    padding: 15px 0px 8px 20px !important;
  }
}
</style>
